import { Button, Step, StepContent, StepLabel, Stepper, } from '@material-ui/core';
import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { get_config_account, isBaseURLAll, set_base_configURL, } from '../../api';
import { AccessRoles } from '../../constants/AccessLevel';
import { AccountSelector } from '../commons/AccountSelector';
import { SnackbarComponent } from '../commons/SnackbarComponent';
import { configFormInitialValues, } from '../commons/assets/InitialValues';
import { configValidationSchema } from '../commons/validation/ConfigValidation';
import { ButtonWrapper, ButtonWrapper2, ContentWrapper, FormContainer, FormLayout, FormWrapper, Title, TitleWrapper, Wrapper, } from './Config.Styles';
import { ConnectForm } from './ConnectForm';
import { DialerDefaultsForm } from './DialerDefaultsForm';
export var ConfigMainView = function (_a) {
    var getDialerDefaults = _a.getDialerDefaults, getGlobalConfig = _a.getGlobalConfig, getAWSRegions = _a.getAWSRegions, updateGlobal = _a.updateGlobal, contactFlows = _a.contactFlows, accessLevel = _a.accessLevel, connectConfig = _a.connectConfig, dialerDefaultsConfig = _a.dialerDefaultsConfig, initialGlobalConfig = _a.initialGlobalConfig, dialerDefaults = _a.dialerDefaults, getContactFlowList = _a.getContactFlowList, selectedAccount = _a.selectedAccount, setAccount = _a.setAccount, awsRegions = _a.awsRegions;
    var _b = useState(false), openSnack = _b[0], setOpenSnack = _b[1];
    var _c = useState(''), snackMessage = _c[0], setSnackMessage = _c[1];
    var _d = useState('success'), severity = _d[0], setSeverity = _d[1];
    var step = useState(0)[0];
    var _e = useState(true), openStepOne = _e[0], setOpenStepOne = _e[1];
    var _f = useState(true), openStepTwo = _f[0], setOpenStepTwo = _f[1];
    console.log('selected acc is', selectedAccount);
    var handleSubmit = function (submitForm) {
        submitForm();
    };
    var handleClose = function () {
        setOpenSnack(false);
    };
    var handleUpdateCallback = function (data, type) {
        var status = data.action.type;
        if (status === 'UPDATE_GLOBAL_CONFIG_FULFILLED' ||
            status === 'UPDATE_TWILIO_AUTH_FULFILLED') {
            setSnackMessage(type + " Updated!");
            setSeverity('success');
        }
        else if (data.errorMessage && data.errorMessage.includes('409')) {
            setSnackMessage('Data state is stale; refresh & retry!');
            setSeverity('error');
        }
        else {
            setSnackMessage('Update Failed!');
            setSeverity('error');
        }
        setOpenSnack(true);
    };
    useEffect(function () {
        if (isBaseURLAll()) {
            setAccount(get_config_account());
            set_base_configURL();
        }
        getAWSRegions();
    }, []);
    useEffect(function () {
        getGlobalConfig();
        getDialerDefaults();
        getContactFlowList();
    }, [selectedAccount]);
    // useEffect(() => {
    //   //TODO
    // }, [selectedAccount]);
    var onSend = function (values) {
        var globalSubmit = {
            Connect: {
                AwsRegion: values.awsRegion,
                InstanceArn: values.instanceArn,
                ConnectProjectCPS: values.connectProjectCPS
            },
            DialerDefaults: {
                ScheduleTimezone: values.scheduleTimezone,
                ContactFlowId: values.contactFlowId,
                InitialCpaMin: values.initialCpa[0],
                InitialCpaMax: values.initialCpa[1],
                MaxCPA: values.maxCpa,
                InitialPacingDurationMin: values.initialPacingDurationMin,
                InitialPacingDurationMax: values.initialPacingDurationMax,
                InitialPacingSamplesMin: values.initialPacingSamplesMin,
                InitialPacingSamplesMax: values.initialPacingSamplesMax,
                AbandonmentIncrementMin: values.abandonmentIncrementMin,
                AbandonmentIncrementMax: values.abandonmentIncrementMax,
                CpaModifierMin: values.cpaModifierMin,
                CpaModifierMax: values.cpaModifierMax,
                AbaTargetRateMin: values.abaTargetRateMin,
                AbaTargetRateMax: values.abaTargetRateMax,
                CallLimitRecordMin: values.callLimitRecord[0],
                CallLimitRecordMax: values.callLimitRecord[1],
                CallLimitPhoneMin: values.callLimitPhone[0],
                CallLimitPhoneMax: values.callLimitPhone[1],
                ScheduleLoopsMin: values.scheduleLoops[0],
                ScheduleLoopsMax: values.scheduleLoops[1],
                ConcurrentCallsMin: values.concurrentCallsMin,
                ConcurrentCallsMax: values.concurrentCallsMax
            }
        };
        updateGlobal(globalSubmit, function (data) {
            handleUpdateCallback(data, 'Global Configuration');
        }, initialGlobalConfig);
    };
    var setFormValues = function (setValues) {
        var connectValues = connectConfig;
        var dialerDefaultsValues = dialerDefaultsConfig;
        if (connectValues &&
            dialerDefaultsValues &&
            Object.keys(connectValues).length &&
            Object.keys(dialerDefaultsValues).length) {
            var template = {
                awsRegion: connectValues.AwsRegion,
                instanceArn: connectValues.InstanceArn,
                connectProjectCPS: connectValues.ConnectProjectCPS,
                scheduleTimezone: dialerDefaultsValues.ScheduleTimezone,
                contactFlowId: dialerDefaultsValues.ContactFlowId,
                abandonmentIncrementMin: dialerDefaultsValues.AbandonmentIncrementMin,
                abandonmentIncrementMax: dialerDefaultsValues.AbandonmentIncrementMax,
                cpaModifierMin: dialerDefaultsValues.CpaModifierMin,
                cpaModifierMax: dialerDefaultsValues.CpaModifierMax,
                abaTargetRateMin: dialerDefaultsValues.AbaTargetRateMin,
                abaTargetRateMax: dialerDefaultsValues.AbaTargetRateMax,
                concurrentCallsMin: dialerDefaultsValues.ConcurrentCallsMin,
                concurrentCallsMax: dialerDefaultsValues.ConcurrentCallsMax,
                initialPacingDurationMin: dialerDefaultsValues.InitialPacingDurationMin,
                initialPacingDurationMax: dialerDefaultsValues.InitialPacingDurationMax,
                initialPacingSamplesMin: dialerDefaultsValues.InitialPacingSamplesMin,
                initialPacingSamplesMax: dialerDefaultsValues.InitialPacingSamplesMax,
                maxCpa: dialerDefaultsValues.MaxCPA,
                initialCpa: [
                    dialerDefaultsValues.InitialCpaMin,
                    dialerDefaultsValues.InitialCpaMax,
                ],
                scheduleLoops: [
                    dialerDefaultsValues.ScheduleLoopsMin,
                    dialerDefaultsValues.ScheduleLoopsMax,
                ],
                callLimitRecord: [
                    dialerDefaultsValues.CallLimitRecordMin,
                    dialerDefaultsValues.CallLimitRecordMax,
                ],
                callLimitPhone: [
                    dialerDefaultsValues.CallLimitPhoneMin,
                    dialerDefaultsValues.CallLimitPhoneMax,
                ]
            };
            setValues(template);
        }
    };
    return (React.createElement(Wrapper, null,
        React.createElement(TitleWrapper, null,
            React.createElement(Title, { variant: 'h6', gutterBottom: true }, "Global Configuration" + (accessLevel !== AccessRoles.ADMINISTRATOR
                ? " (Read Only for " + accessLevel.toUpperCase() + ")"
                : '')),
            ' ',
            React.createElement(ButtonWrapper2, null,
                React.createElement(AccountSelector, { initialValue: selectedAccount, onValueChange: function (data) { return setAccount(data); }, noAll: true }))),
        React.createElement(FormWrapper, null,
            React.createElement(FormLayout, null,
                React.createElement(FormContainer, null,
                    React.createElement(Formik, { initialValues: configFormInitialValues, validationSchema: configValidationSchema, onSubmit: function (values, _a) {
                            var setSubmitting = _a.setSubmitting;
                            onSend(values);
                            setSubmitting(false);
                        } }, function (_a) {
                        var submitForm = _a.submitForm, values = _a.values, errors = _a.errors, setValues = _a.setValues;
                        return (React.createElement(Form, null,
                            useEffect(function () {
                                setTimeout(function () {
                                    setFormValues(setValues);
                                }, 400);
                            }, [connectConfig, dialerDefaultsConfig]),
                            React.createElement(Stepper, { activeStep: step, orientation: 'vertical' },
                                React.createElement(Step, { active: openStepOne },
                                    React.createElement(StepLabel, { onClick: function () {
                                            setOpenStepOne(!openStepOne);
                                        } }, "Connect"),
                                    React.createElement(StepContent, null,
                                        React.createElement(ConnectForm, { awsRegion: values === null || values === void 0 ? void 0 : values.awsRegion, awsRegions: awsRegions }, "Connect"))),
                                React.createElement(Step, { active: openStepTwo },
                                    React.createElement(StepLabel, { onClick: function () {
                                            setOpenStepTwo(!openStepTwo);
                                        } }, "Dialer Defaults"),
                                    React.createElement(StepContent, null,
                                        React.createElement(ContentWrapper, { disable: accessLevel !== AccessRoles.ADMINISTRATOR },
                                            React.createElement(DialerDefaultsForm, { contactFlows: contactFlows || [], formValues: values, errors: errors })))),
                                React.createElement(Step, { expanded: true },
                                    React.createElement(StepContent, null,
                                        React.createElement(ButtonWrapper, null,
                                            React.createElement(Button, { variant: 'contained', color: 'primary', onClick: function () { return handleSubmit(submitForm); }, disabled: accessLevel !== AccessRoles.ADMINISTRATOR }, "Save Changes"))))),
                            React.createElement(SnackbarComponent, { anchorOrigin: {
                                    vertical: 'top',
                                    horizontal: 'center'
                                }, open: openSnack, autoHideDuration: 6000, onAlertClose: handleClose, alertMessage: snackMessage, severity: severity })));
                    }))))));
};
ConfigMainView.defaultProps = {};
//# sourceMappingURL=Config.js.map